import loadEmscriptenModule from '../core/internal/loadEmscriptenModuleNode.js';
import runPipelineEmscripten from './internal/runPipelineEmscripten.js';
async function runPipelineNode(pipelinePath, args, outputs, inputs) {
    const Module = await loadEmscriptenModule(pipelinePath);
    const result = runPipelineEmscripten(Module, args, outputs, inputs);
    return result;
}
export default runPipelineNode;
//# sourceMappingURL=runPipelineNode.js.map